import { useParams } from "react-router-dom";

import { useCurrentUser, useUser } from "../../api/hooks";

import { UserData } from "./schema";

interface UserDataResponse {
	data: UserData;
	isLoading: boolean;
}

/**
 * Use useDocumentsUserData hook to fetch required user data for documents page.
 */
const useDocumentsUserData = (): UserDataResponse => {
	// Get user ID of logged in user
	const { data: thisUser, isLoading: thisUserLoading } = useCurrentUser();
	const thisUserId = thisUser?.me?.authorization?.payload?.user_id || "";

	// Determine if this user's primary role is one of admin roles
	const adminRoles = ["billing-admin", "admin", "basic-admin"];
	const thisUserRole = thisUser?.me?.authorization?.payload?.user_primary_role || "";
	const userIsAdmin = adminRoles.includes(thisUserRole);

	// Get user ID of employee from params
	const params = useParams();
	const employeeID = params?.userID || thisUserId || "";

	// Get name of employee
	const { data: employee, isLoading: employeeLoading } = useUser({ userID: employeeID, disabled: !employeeID });
	const employeeName = employee?.name || "";

	const data: UserData = {
		employeeID,
		thisUserId,
		employeeName,
		userIsAdmin,
	};

	return {
		data,
		isLoading: thisUserLoading || employeeLoading,
	};
};

export default useDocumentsUserData;
